import { defineMessages } from 'react-intl';
export
// eslint-disable-line import/prefer-default-export
var messages = defineMessages({
  contentTypeSwitchers: {
    id: "Tours.LessonDetails.contentTypeSwitchers",
    defaultMessage: [{
      "type": 0,
      "value": "Choose preferable lesson format(s) here"
    }]
  },
  navigationButton: {
    id: "Tours.LessonDetails.navigationButton",
    defaultMessage: [{
      "type": 0,
      "value": "Easily move between lessons here"
    }]
  },
  highlight: {
    id: "Tours.LessonDetails.highlight",
    defaultMessage: [{
      "type": 0,
      "value": "Add lesson contents to notes by selecting text and then clicking “Highlight”"
    }]
  },
  videoNote: {
    id: "Tours.LessonDetails.videoNote",
    defaultMessage: [{
      "type": 0,
      "value": "Click \"Add video comment\" to add comment on the video timeline"
    }]
  },
  completeButton: {
    id: "Tours.LessonDetails.completeButton",
    defaultMessage: [{
      "type": 0,
      "value": "When 90% of text or video is studied, lesson will be automatically marked completed. You can also manually press \"Complete\" button"
    }]
  }
});